export enum FILE_ERROR_TYPES {
  FILE_TOO_BIG = 1,
  FILE_TYPE_INVALID = 2,
}
